import { useToast } from "../../hooks/useToast";
import styles from "./Toast.module.scss"
import install from "../../assets/icons/install.svg"

const ToastContainer = () => {
    const { toasts } = useToast();

    return (
        <div className={styles.tooltipWrapper}>
            {toasts.map((toast) => (
                <div key={toast.id} className={styles.toast}>
                    {toast.icon && (<img src={install} alt="install" />)}

                    {toast.message}
                </div>
            ))}
        </div>
    );
};

export default ToastContainer;
